<div class="terms-card-container">
  <label class="checkbox-label">
<input
  type="checkbox"
  class="terms-checkbox"
  [(ngModel)]="termsAccepted"
  (ngModelChange)="onTermsChange()"
  (keydown.enter)="termsAccepted = !termsAccepted; onTermsChange()"
/>
    
  <span class="terms-text">
    {{ 'web.accept' | translate }}
    <button class="terms-link" (click)="onViewLink('web.termsAndConditionsLink')">
      {{ 'web.termsAndConditions' | translate }}
    </button>
    {{ 'web.and' | translate }}
    <button class="terms-link" (click)="onViewLink('web.travelRulesLink')">
      {{ 'web.travelRules' | translate }}
    </button>
    <span class="required">*</span>
  </span>
  </label>
</div>
